<template>
  <dx-modal title="Selecione o dia da semana para encaixe"
            :value="show" @input="close" id="modal-week-day-selector">
    <div v-if="showPatientInfo" class="card patient-card">
      <div class="card-header">
        <div class="card-title">Dados do paciente</div>
      </div>
      <div class="card-body">
        <div class="columns">
          <div class="column col-6 mb-1">
            <strong>Nome:</strong>
            <span class="ml-1">{{ clipboard.data.patient.name }}</span>
          </div>
          <div class="column col-6 mb-1">
            <strong>Nascimento:</strong>
            <span class="ml-1">{{ clipboard.data.patient.birthDate | date }}</span>
          </div>
          <div class="column col-6">
            <strong>Celular:</strong>
            <span class="ml-1">{{ clipboard.data.patient.cellphone | phone }}</span>
          </div>
          <div class="column col-6">
            <strong>Telefone:</strong>
            <span class="ml-1">{{ clipboard.data.patient.phone | phone }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="week-days-selector">
      <div class="week-days-horizontal">
        <button
          v-for="day in weekDays"
          :key="day.date"
          class="btn week-day-button"
          :class="{
            'btn-primary': selectedDate === day.date,
            'btn-gray': selectedDate !== day.date,
          }"
          @click="selectDay(day.date)"
        >
          <div class="week-day-label">{{ day.weekday }}</div>
          <div class="week-day-date">{{ day.displayDate }}</div>
          <div class="week-day-full-date">{{ formatFullDate(day.date) }}</div>
        </button>
      </div>
    </div>

    <template slot="footer">
      <button class="btn" @click="close">Sair</button>
    </template>
  </dx-modal>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';

export default {
  props: {
    show: {
      type: Boolean,
    },
    weekDays: {
      type: Array,
      required: true,
    },
    showPatientInfo: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedDate: null,
    };
  },
  computed: {
    ...mapState({
      clipboard: ({ appointment }) => appointment.clipboard,
    }),
  },
  methods: {
    close() {
      this.selectedDate = null;
      this.$emit('close');
    },
    selectDay(date) {
      this.selectedDate = date;
      // Emite o evento imediatamente ao selecionar um dia
      this.$emit('day-selected', date);
    },
    formatFullDate(date) {
      return moment(date).format('DD/MM/YYYY');
    },
  },
};
</script>

<style lang="scss">
@import '../../../../assets/scss/variables';

#modal-week-day-selector {
  .patient-card {
    background-color: $gray-color-ultra-light;
    margin-bottom: $layout-spacing;
  }

  .week-days-selector {
    margin-top: $layout-spacing;
  }

  .week-days-horizontal {
    display: flex;
    flex-wrap: wrap;
    gap: $layout-spacing-sm;
    justify-content: center;
  }

  .week-day-button {
    flex: 1;
    min-width: 100px;
    max-width: 120px;
    padding: $layout-spacing-sm;
    text-align: center;
    min-height: 80px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 2px solid $border-color !important;
    transition: border-color 0.2s ease;
    background-color: $light-color !important;
    color: $dark-color !important;

    &.btn-primary {
      background-color: $light-color !important;
      color: $dark-color !important;
      border-color: $primary-color !important;
    }

    &.btn-gray {
      background-color: $light-color !important;
      color: $dark-color !important;
    }

    &:hover {
      border-color: $primary-color !important;
    }

    .week-day-label {
      font-weight: 600;
      font-size: $font-size-sm;
      margin-bottom: $unit-1;
      color: $dark-color;
    }

    .week-day-date {
      font-size: $font-size-lg;
      font-weight: 700;
      margin-bottom: $unit-1;
      color: $dark-color;
    }

    .week-day-full-date {
      font-size: $font-size-xs;
      opacity: 0.7;
      color: $dark-color;
    }
  }
}
</style>
